module.exports = __webpack_public_path__ + "img/img-dingzhi-s3-tuya.62e60ba7.jpg";